import { graphql } from "gatsby";
import React, { FC } from "react";

import { useLabels } from "../../contexts/labels";
import { renameFields } from "../../utils/object";
import { HeaderMenu } from "./header-menu";
import { HeaderMenuLabels } from "./types";

export interface HeaderMenuSectionProps {
  headerMenu: Queries.HeaderMenuDataFragment;
  pageContentfulId: string | null;
  internalPagePath: string | null;
}

export const HeaderMenuSection: FC<HeaderMenuSectionProps> = ({
  headerMenu,
  pageContentfulId,
  internalPagePath,
}) => {
  const labelsMap: Record<keyof HeaderMenuLabels, string | null> = {
    "header-menu-locale-selector-title": null,
    "header-menu-locale-selector-country": null,
    "header-menu-locale-selector-language": null,
    "header-menu-locale-selector-submit": null,
    "header-menu-search-title": null,
    "header-menu-search-placeholder": null,
    "header-menu-search-submit": null,
    "header-menu-store-locator-title": null,
    "header-menu-personal-area-login-title": null,
    "header-menu-personal-area-login-body": null,
    "header-menu-personal-area-login-cta": null,
    "header-menu-personal-area-signup-title": null,
    "header-menu-personal-area-signup-body": null,
    "header-menu-personal-area-signup-cta": null,
    "header-menu-personal-area-authenticated-title": null,
    "header-menu-personal-area-authenticated-greeting": null,
    "header-menu-personal-area-authenticated-body": null,
    "header-menu-personal-area-logout-cta": null,
    "header-menu-personal-area-profile-card-title": null,
    "header-menu-personal-area-profile-card-body": null,
    "header-menu-personal-area-profile-card-cta": null,
    "header-menu-personal-area-agenda-card-title": null,
    "header-menu-personal-area-agenda-card-body": null,
    "header-menu-personal-area-agenda-card-cta": null,
  };

  const { labels: stringLabels } = useLabels();

  const labels = renameFields(stringLabels, labelsMap) as HeaderMenuLabels;

  return (
    <HeaderMenu
      labels={labels}
      pageContentfulId={pageContentfulId}
      internalPagePath={internalPagePath}
      headerMenu={headerMenu}
    />
  );
};

export const query = graphql`
  fragment HeaderMenuData on ContentfulHeaderMenu {
    node_locale
    primaryItems {
      __typename
      ... on ContentfulHeaderMenuItem {
        ...HeaderMenuItemData
      }
      ... on ContentfulCta {
        id
        ...CtaData
      }
    }
    secondaryItems {
      __typename
      ... on ContentfulHeaderMenuItem {
        ...HeaderMenuItemData
      }
      ... on ContentfulCta {
        id
        ...CtaData
      }
    }
    localeSelectorImage {
      gatsbyImageData
    }
    storeLocatorPage {
      id
    }
  }
`;
